// htmxEvents.js
import nativeLazy from './native-lazy';
import eventDates from './event-dates';

const htmxEvents = {
    // Store the trigger element
    lastTrigger: null,

    init() {
        if (typeof htmx !== 'undefined') {
            this.setupScrollBehavior();
            this.setupLoadingStates();
        }
    },

    setupScrollBehavior() {
        // Store trigger before request
        htmx.on('htmx:beforeRequest', (event) => {
            this.lastTrigger = event.target;
        });

        htmx.on('htmx:afterSwap', (event) => {
            nativeLazy();
            eventDates.init();

            const container = event.detail.target.querySelector('#sprig-container')
            ?? event.detail.target.querySelector('#sprig-login')
            ?? document.querySelector('#sprig-parent');

            // Use stored trigger
            const trigger = this.lastTrigger;

            if (!container) return;
            const top = container.offsetTop - 200;

            // If trigger has 's-no-scroll' attribute, target has class 'no-scroll' or a 'no-scroll' child, don't scroll
            if (trigger?.hasAttribute('s-no-scroll') ||
                container.classList.contains('no-scroll') ||
                container.querySelector('.no-scroll')) {
                return;
            }

            window.scrollTo({top: (top || 0), behavior: 'smooth'});
        });
    },

    setupLoadingStates() {
        htmx.on('htmx:beforeRequest', function(event) {
            const trigger = event.target;
            const modal = trigger?.closest('.modal');

            if (modal) {
                modal.classList.add('is-loading');
            } else {
                event.detail.target.classList.add('is-loading');
                if (trigger?.classList?.contains('sprig-loading')) {
                    trigger?.classList?.add('is-loading');
                }
            }
        });

        htmx.on('htmx:afterRequest', function(event) {
            const trigger = event.target;
            const modal = trigger?.closest('.modal');

            if (modal) {
              modal.classList.remove('is-loading');
            } else {
                event.detail.target.classList.remove('is-loading');
                setTimeout(() => {
                    trigger?.classList?.remove('is-loading');
                }, 300);
            }

            nativeLazy();
        });
    }
};

export default htmxEvents;
